import styled from 'styled-components'

export const Asterisk = styled.span`
    &::after {
        content: '*';
        color: red;
    }
`
export const SaveFooter = styled.span`
    width: 100%;
    padding: 14px 45px;
    position: fixed;
    bottom: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    background: ${({ theme }) => theme['gray-200']};
`
export const RowRemoveButton = styled.button`
    width: 40px;
    height: 40px;
    border: none;
    background: var(--gray-200);
    color: var(--gray-600);
    transition: all 0.5s;
    &:hover {
        color: var(--gray-0);
        background: var(--red-500);
    }
`
export const AddRowButton = styled.button`
    border: none;
    background: ${({ theme }) => theme['blue-200']};
    color: ${({ theme }) => theme['blue-500']};
    padding: 8px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 13px;
    font-family: ${({ theme }) => theme['font-semibold']};
    text-transform: capitalize;
    width: 100%;

    &:focus {
        border: 1px solid ${({ theme }) => theme['blue-500']};
    }
    i {
        margin-right: 8px;
    }
`
